import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "output"]

  connect() {
    this.lastGeneratedValue = this.slugify(this.sourceTarget.value)
    this.locked = this.shouldLock()
    this.sync()
  }

  sync() {
    const generatedValue = this.slugify(this.sourceTarget.value)

    if (!this.locked) {
      this.outputTarget.value = generatedValue
    }

    this.lastGeneratedValue = generatedValue
  }

  lock() {
    this.locked = this.shouldLock()
  }

  slugify(value) {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  }

  shouldLock() {
    const currentValue = this.outputTarget.value.trim()

    return currentValue.length > 0 && currentValue !== this.lastGeneratedValue
  }
}
